/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { PlatformCategory } from './platform-category';
// May contain unused imports in some cases
// @ts-ignore
import type { SnsAccountError } from './sns-account-error';

/**
 * 
 * @export
 * @interface GetViewupPlusSnsAccountsByUserUuidDataElementDto
 */
export interface GetViewupPlusSnsAccountsByUserUuidDataElementDto {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'snsAccountUuid': string;
    /**
     * 계정 ID
     * @type {string}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'snsId': string;
    /**
     * 활동기능 여부
     * @type {boolean}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'isActivity'?: boolean;
    /**
     * 적립 금액
     * @type {number}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'totalPoint': number;
    /**
     * 생성 일시
     * @type {string}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'createdAt': string;
    /**
     * 플렛폼 카테고리
     * @type {PlatformCategory}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'platformCategory': PlatformCategory;
    /**
     * sns 계정 에러
     * @type {SnsAccountError}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'snsAccountError': SnsAccountError;
    /**
     * 리그램 여부
     * @type {boolean}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'isRegram'?: boolean;
    /**
     * 승인 상태
     * @type {string}
     * @memberof GetViewupPlusSnsAccountsByUserUuidDataElementDto
     */
    'approvalStatus': GetViewupPlusSnsAccountsByUserUuidDataElementDtoApprovalStatusEnum;
}

export const GetViewupPlusSnsAccountsByUserUuidDataElementDtoApprovalStatusEnum = {
    Pending: 'pending',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type GetViewupPlusSnsAccountsByUserUuidDataElementDtoApprovalStatusEnum = typeof GetViewupPlusSnsAccountsByUserUuidDataElementDtoApprovalStatusEnum[keyof typeof GetViewupPlusSnsAccountsByUserUuidDataElementDtoApprovalStatusEnum];


